import { tikTokEventPropertiesTemplate } from './constants';
import { mountTikTokEvent } from './mountTikTokEvent';
import { TikTokEvent } from './types';

import type {
  TikTokBaseEventProperties,
  TikTokBaseUserDataArgs,
} from './types';

export function mountTikTokAddToCart(args: TikTokBaseUserDataArgs) {
  const properties: TikTokBaseEventProperties = {
    ...tikTokEventPropertiesTemplate,
    event_id: args.event_id,
  };
  mountTikTokEvent({
    eventName: TikTokEvent.AddToCart,
    properties,
    identifyData: { email: args.email },
  });
}
